module.exports = __webpack_public_path__ + "static/media/BG_3.2938eaa6.png";